/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Interface for the parameters to be passed into satelliteServicesFunction
 */
export var MetricType;
(function (MetricType) {
    MetricType[MetricType["COUNTER"] = 0] = "COUNTER";
    MetricType[MetricType["TIMER"] = 1] = "TIMER";
})(MetricType || (MetricType = {}));
/**
 * Interface for the different types of messages used internally.
 */
export var MessageType;
(function (MessageType) {
    // changing the assigned number is considered backward incompatible
    MessageType[MessageType["HANDSHAKE"] = 0] = "HANDSHAKE";
    MessageType[MessageType["HANDSHAKE_REPLY"] = 1] = "HANDSHAKE_REPLY";
    MessageType[MessageType["REQUEST"] = 2] = "REQUEST";
    MessageType[MessageType["REPLY"] = 3] = "REPLY";
    MessageType[MessageType["EMIT"] = 4] = "EMIT";
    MessageType[MessageType["RESIZE"] = 5] = "RESIZE";
    MessageType[MessageType["USER_EVENT_PAYLOAD"] = 6] = "USER_EVENT_PAYLOAD";
    MessageType[MessageType["REPLY_EXCEPTION"] = 7] = "REPLY_EXCEPTION";
    MessageType[MessageType["TITLE_CHANGE"] = 8] = "TITLE_CHANGE";
    MessageType[MessageType["SERVICE_WORKER_CLIENT_REQUEST_HANDSHAKE"] = 9] = "SERVICE_WORKER_CLIENT_REQUEST_HANDSHAKE";
})(MessageType || (MessageType = {}));
/**
 * Fallback timeout error used when execution takes longer than expected, and should stop waiting
 * (e.g. reject Promise). A retry is possible.
 */
export class SatelliteTimeoutError extends Error {
}
//# sourceMappingURL=Interfaces.js.map